import { Component, OnInit, Input, Injectable, Renderer2 } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import { Router } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormArray,
} from "@angular/forms";
import { PatientDialogService } from "src/app/services/Non-Master/PatientDialog.service";
import { MastersKeyStringValue } from "src/app/services/Non-Master/MastersKeyStringValue.service";
import { formatDate, DatePipe } from "@angular/common";
import { Local } from "protractor/built/driverProviders";
import {
  SystemDefaultModel,
  ChineseDefaultModel,
  EnglishDefaultModel,
} from "src/app/models/non-master-model/SystemDefaultModel";
import { DateTimeConvertService } from "src/app/services/CommonService/DateTimeConvert.service";
import {
  tPatientModel,
  tPatientModel_Encrypted,
} from "src/app/models/tPatientModel";
import { BookingDialogService } from "src/app/services/Non-Master/BookingDialog.service";
import { tPackageService } from "src/app/services/tPackage.service";
import { tPatientService } from "src/app/services/tPatient.service";
import { NewPatientDialogService } from "src/app/services/Non-Master/NewPatientDialog.service";
import { tBookingService } from "src/app/services/tBooking.service";
import { tBookingTimeModel, tBookingModel } from "src/app/models/tBookingModel";
import { SearchEmployeeDialogService } from "src/app/services/Non-Master/SearchEmployeeDialog.service";
import { tEmployeeModel } from "src/app/models/tEmployeeModel";
import { SearchItemIDDialogService } from "src/app/services/Non-Master/SearchItemIDDialog.service";
import { tItemModel } from "src/app/models/tItemModel";
import { NavigationComponent } from "src/app/pages/navigation/navigation.component";
import { StatusMessage } from "src/app/shared/StatusMessage";
import { AppSettings } from "src/app/shared/AppSettings";
import { ApiResultHandlerService } from "src/app/services/Non-Master/ApiResultHandler.service";
import { tBookAuxService } from "src/app/services/tBookAux.service";
import { tBookAuxModel } from "src/app/models/tBookAuxModel";
import { AppComponent } from "src/app/app.component";

import { tWaitingConsultService } from "src/app/services/tWaitingConsult.service";
import { isNullOrUndefined } from "util";
import { of } from "rxjs";
import { isObject } from "ngx-pipes/src/pipes/helpers/helpers";
import { DisplayData } from "src/app/models/non-master-model/DisplayData";
import { PathAction } from "src/app/models/non-master-model/PathAction";
import { ApiResultDialogService } from "src/app/services/Non-Master/ApiResultDialog.service";
import { CrypService } from "src/app/services/Non-Master/Cryp.service";
import { tEmployeeService } from "src/app/services/tEmployee.service";
import { tShopModel } from "src/app/models/tShopModel";
import { TranslateService } from "@ngx-translate/core";
import { tOnConsultService } from "src/app/services/tOnConsult.service";
import { tPatientTypeModel } from "src/app/models/tPatientTypeModel";
import { tPatientTypeService } from "src/app/services/tPatientType.service";
import {
  GenderModel,
  GenderTitleModel,
} from "src/app/models/SimpleConfigModel";
import { SimpleConfigService } from "src/app/services/SimpleConfig.service";
import { MatSnackBar } from "@angular/material";
@Component({
  selector: "app-create-waiting-consult-dialog",
  templateUrl: "./create-waiting-consult-dialog.component.html",
  styleUrls: ["./create-waiting-consult-dialog.component.css"],
})
@Injectable()
export class CreateWaitingConsultDialogComponent implements OnInit {
  i18n;

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private patientDialogService: PatientDialogService,
    private searchEmployeeDialogService: SearchEmployeeDialogService,
    private dateTimeConvertService: DateTimeConvertService,
    private tPatientService: tPatientService,
    private newPatientDialogService: NewPatientDialogService,
    private tBookingService: tBookingService,
    private employeeService: tEmployeeService,
    private searchItemIDDialogService: SearchItemIDDialogService,
    private ren: Renderer2,
    private datepipe: DatePipe,
    private apiResultHandlerService: ApiResultHandlerService,
    private tBookAuxService: tBookAuxService,
    private tWaitingConsultService: tWaitingConsultService,
    private apiResultDialogService: ApiResultDialogService,
    private CrypService: CrypService,
    private translate: TranslateService,
    private tOnConsultService: tOnConsultService,
    private datePipe: DatePipe,
    private tPatientTypeService: tPatientTypeService,
    private SimpleConfigService: SimpleConfigService,
    private snackBar: MatSnackBar
  ) {
    this.translate
      .get([
        "msg_caseDoctor_no_select_patient",
        "msg_caseDoctor_no_caseDoctor",
        "msg_patient_no_id_and_DOB",
      ])
      .subscribe((t) => (this.i18n = t));
  }

  get f() {
    return this.editForm.controls;
  }

  patientTypeID_selection: tPatientTypeModel[];
  patientGender_selection;
  // form
  bntStyle: string;
  submitted = false;
  formValidSuccessSubmitted = false;

  editForm: FormGroup;
  editForm_newPatient: FormGroup;
  bookingDateDisplay: string;
  selectedPatient: tPatientModel = new tPatientModel();

  selectedEmpolyee1: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee1_Name = "";
  selectedEmpolyee1_Display = "";

  selectedItemService1: tItemModel = new tItemModel();
  selectedItemService1_Display = "";
  selectedItemService1_Name = "";

  selectedEmpolyee2: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee2_Display = "";
  selectedEmpolyee2_Name = "";

  selectedItemService2: tItemModel = new tItemModel();
  selectedItemService2_Display = "";
  selectedItemService2_Name = "";

  selectedEmpolyee3: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee3_Display = "";
  selectedEmpolyee3_Name = "";

  selectedItemService3: tItemModel = new tItemModel();
  selectedItemService3_Display = "";
  selectedItemService3_Name = "";

  selectedEmpolyee4: tEmployeeModel = new tEmployeeModel();
  selectedEmpolyee4_Display: string;
  selectedEmpolyee4_Name = "";

  selectedItemService4: tItemModel = new tItemModel();
  selectedItemService4_Display: string;
  selectedItemService4_Name = "";

  bookingPatientDisplayName: string;
  bookingPatientDisplayResultName: string;

  timeSlotList: tBookingTimeModel[];
  bookingAuxList: tBookAuxModel[];
  defaultEC: tEmployeeModel;
  clthFollowUpList;

  patientLastPhysioRemark = "";
  userInput: string = "";
  options: string[] = [];
  filteredOptions: string[] = [];
  activeOptionIndex: number = 0;
  genderList: GenderModel[];
  genderTitleList: GenderTitleModel[];
  CheckPatientHKIDMessage="";
  CheckPatientHKIDMessage_PASS="";
  TAG = "CreateWaitingConsultDialogComponent";
  @Input() action: string;
  @Input() tableKeyValue: string;
  @Input() bookingDate: Date;
  @Input() bookingTimeSlotDisplay: string;
  @Input() bookingTimeSlotID: number;

  @Input() bookingNum: string;
  @Input() patientID: string;
  @Input() bkPatientName: string;
  @Input() bkDoctorID?: string;

  // checkbox
  bookingAuxData = [];

  ecTypeSelectList: tEmployeeModel[];

  showChangePatientBtn = false;
  showCreatePatientBtn = false;
  isNewPatient = false;
  isChecking = false;

  ngOnInit() {
    this.bntStyle = "btn-default";
    if (this.patientID == "newPatient") {
      this.isNewPatient = true;

      this.getGender();
      this.loadOptions();
      this.getPatientTypeList();
    } else {
      this.isNewPatient = false;
    }
    // this.bookingDateDisplay = this.dateTimeConvertService.ConvertCurrentDayWeek(this.bookingDate);

    this.setDefaultLanguageString(AppComponent.usingLanguage);
    if (this.isNewPatient == true) {
      this.editForm = this.formBuilder.group({
        shopID: [NavigationComponent.selectedShopID],
        bkBookingNumber: [],
        bkPatientID: ["", [Validators.required]],
        bkBookedDate: [],
        bkBookedTimeSlot: [this.bookingTimeSlotID],
        bkBookingStatus: ["OPEN"],
        bkBookAuxID: [],
        bkBookAuxIDAll: new FormArray([]),
        bkBookAuxName: ["", ""],
        bkItemID1: ["", ""],
        bkItemDescMobile1: [""],
        bkTherapistID1: ["", ""],
        bkTherapistName1: ["", ""],
        bkItemID2: ["", ""],
        bkItemDescMobile2: [""],
        bkTherapistID2: ["", ""],
        bkTherapistName2: ["", ""],
        bkItemID3: ["", ""],
        bkItemDescMobile3: [""],
        bkTherapistID3: ["", ""],
        bkTherapistName3: ["", ""],
        bkItemID4: ["", ""],
        bkItemDescMobile4: [""],
        bkTherapistID4: ["", ""],
        bkTherapistName4: ["", ""],
        bkPatientPhone: ["", ""],
        bkBookRemark: ["", ""],
        bkPatientName: ["", [Validators.required]],
        // clthConsultNumber: [],          // Auto Gen in Backend
        // clthArrivalDateTime: [],        // Auto Gen in Backend
        clthPatientID: [], // = bkPatientID
        clthBookNumber: [], // = bkBookingNumber (Optional)
        clthPrescripNumber: [], // Null
        clthBillingNumber: [], // Null
        clthBedNumber: [], // Null
        clthDiagonsis: [], // Null
        clthDetailDesc: [], // Null
        clthFollowUpDesc: [], // Null
        clthRequestServiceName: [], // = bkItemDescMobile1
        clthRequestTherapistName: [], // = bkTherapistName1
        clthRemark: [], // = bkBookRemark

        clthFollowUp: new FormControl(this.clthFollowUpList[0].value),
        clthAuxName: [], // = bkBookAuxName

        clthTherapistID: ["", [Validators.required]],
        clthTherapistName: [],

        lastModifyDatetime: ["", ""],
        lastModifyUserID: [],
        InActive: [],
        patientType: [],
        patientGender: [],
        patientIHKID: ["", [Validators.required]],
        patientHKIDRemark: [],
        patientDob: ["", [Validators.required]],
        patientCaseDr: ["", [Validators.required]],
        patientRemark2: [],
        patientNonHKIDHolder: false,
        patientAddress: [],
        patientSurname: [],
      });
    } else {
      this.editForm = this.formBuilder.group({
        shopID: [NavigationComponent.selectedShopID],
        bkBookingNumber: [],
        bkPatientID: ["", [Validators.required]],
        bkBookedDate: [],
        bkBookedTimeSlot: [this.bookingTimeSlotID],
        bkBookingStatus: ["OPEN"],
        bkBookAuxID: [],
        bkBookAuxIDAll: new FormArray([]),
        bkBookAuxName: ["", ""],
        bkItemID1: ["", ""],
        bkItemDescMobile1: [""],
        bkTherapistID1: ["", ""],
        bkTherapistName1: ["", ""],
        bkItemID2: ["", ""],
        bkItemDescMobile2: [""],
        bkTherapistID2: ["", ""],
        bkTherapistName2: ["", ""],
        bkItemID3: ["", ""],
        bkItemDescMobile3: [""],
        bkTherapistID3: ["", ""],
        bkTherapistName3: ["", ""],
        bkItemID4: ["", ""],
        bkItemDescMobile4: [""],
        bkTherapistID4: ["", ""],
        bkTherapistName4: ["", ""],
        bkPatientPhone: ["", ""],
        bkBookRemark: ["", ""],
        // bkPatientName: ["", [Validators.required]],
        bkPatientName: [""],
        // clthConsultNumber: [],          // Auto Gen in Backend
        // clthArrivalDateTime: [],        // Auto Gen in Backend
        clthPatientID: [], // = bkPatientID
        clthBookNumber: [], // = bkBookingNumber (Optional)
        clthPrescripNumber: [], // Null
        clthBillingNumber: [], // Null
        clthBedNumber: [], // Null
        clthDiagonsis: [], // Null
        clthDetailDesc: [], // Null
        clthFollowUpDesc: [], // Null
        clthRequestServiceName: [], // = bkItemDescMobile1
        clthRequestTherapistName: [], // = bkTherapistName1
        clthRemark: [], // = bkBookRemark

        clthFollowUp: new FormControl(this.clthFollowUpList[0].value),
        clthAuxName: [], // = bkBookAuxName

        clthTherapistID: ["", [Validators.required]],
        clthTherapistName: [],

        lastModifyDatetime: ["", ""],
        lastModifyUserID: [],
        InActive: [],
        patientType: [],
        patientGender: [],
        patientIHKID: [],
        patientHKIDRemark: [],
        patientDob: [],
        patientCaseDr: [""],
        patientRemark2: [],
        patientNonHKIDHolder: false,
      });
    }

    this.getAllData();

    if (this.patientID !== "") {
      this.getPreviousPatientName(
        NavigationComponent.selectedShopID.toString(),
        this.patientID
      );
    } else {
      this.searchPatientID();
    }
  }

  getAllData(): void {
    this.getEC_AllowSelectList();
    // this.tBookingService.getBookingTimeSlot().subscribe(data => {
    //   this.timeSlotList = data;
    //   this.log.i(this.TAG, "getBookingTimeSlot dataList = " + JSON.stringify(this.timeSlotList));
    // });

    if (this.bookingNum !== "" && this.patientID !== "") {
      this.tBookingService
        .getBookingNumberInfo(
          NavigationComponent.selectedShopID,
          this.bookingNum,
          this.patientID
        )
        .subscribe(
          (data) => {
            // this.timeSlotList = data;
            // this.log.i(this.TAG, 'getBookingNumberInfo getDataById = ' + JSON.stringify(data));
            this.editForm.patchValue(data);
            setTimeout(() => {
              this.log.i(
                "clthTherapistID2:",
                this.editForm.get("clthTherapistID").value
              );
              this.editForm.get("clthTherapistID").setValue(data.bkDoctorID);
              this.editForm.get("bkPatientName").setValue(this.bkPatientName);
              // this.editForm.get('patientCaseDr').setValue(data.bkDoctorID);
              this.editForm
                .get("clthTherapistName")
                .setValue(data.bkDoctorName);
              this.log.i(
                "clthTherapistID:",
                this.editForm.get("clthTherapistID").value
              );
            }, 400);
            this.initRequestService(data);

            this.getBookAuxService(JSON.parse(data.bkBookAuxID));
          },
          (error) => {
            this.log.i(this.TAG, "onsubmit error = " + JSON.stringify(error));
            // this.apiResultHandlerService.ErrHandler();
          }
        );
    } else {
      this.getBookAuxService(null);
    }
  }

  getEC_AllowSelectList() {
    // ecAllowSelectList
    this.employeeService
      .getEmployeeTypeList(NavigationComponent.selectedShopID, 5)
      .subscribe(
        (data) => {
          // this.timeSlotList = data;
          // this.log.i(this.TAG, 'getEmployeeTypeList  = ' + JSON.stringify(data));

          this.ecTypeSelectList = [];
          //filter
          for (var i = 0; i < data.empolyeeList.length; i++) {
            //check need put
            var checkingEmployeeShopList: tShopModel[] = JSON.parse(
              data.empolyeeList[i].employeeRemark1
            );

            for (var p = 0; p < checkingEmployeeShopList.length; p++) {
              if (
                checkingEmployeeShopList[p].shopID ==
                NavigationComponent.selectedShopID
              ) {
                this.ecTypeSelectList.push(data.empolyeeList[i]);
                break;
              }
            }
          }

          //set default ec
          const defaultEC: tEmployeeModel = data.defaultEmpolyee;
          const selectedDoctor = data.empolyeeList.find(
            (z) => z.employeeID === this.bkDoctorID
          );
          console.log("selectedDoctor = " + JSON.stringify(selectedDoctor));

          if (!this.editForm.get("clthTherapistID").value) {
            if (selectedDoctor) {
              this.editForm.patchValue({
                clthTherapistID: selectedDoctor.employeeID,
                clthTherapistName: selectedDoctor.employeeChiName,
              });
            } else if (defaultEC != null && defaultEC != undefined) {
              (<FormControl>(
                this.editForm.controls["clthTherapistName"]
              )).setValue(defaultEC.employeeChiName);
              (<FormControl>this.editForm.controls["clthTherapistID"]).setValue(
                defaultEC.employeeID
              );
            }
          }
          /*

      if(!this.editForm.get('patientCaseDr').value){
          if(defaultEC!=null){
                      (<FormControl>this.editForm.controls['patientCaseDr']).setValue(defaultEC.employeeID);

          }

      }
*/

          //  this.defaultEC = data.defaultEmpolyee;
          //  if (this.defaultEC != null && this.defaultEC != undefined) {
          //   (<FormControl>this.editForm.controls['clthTherapistName']).setValue(this.defaultEC.employeeChiName);
          //   (<FormControl>this.editForm.controls['clthTherapistID']).setValue(this.defaultEC.employeeID);
          //   }

          // this.ecTypeSelectList = data.empolyeeList;
        },
        (error) => {
          this.log.i(this.TAG, "error = " + JSON.stringify(error));
        }
      );
  }

  initRequestService(data: tBookingModel) {
    if (
      data.bkItemID1 != null &&
      data.bkItemID1 !== undefined &&
      data.bkItemID1 !== ""
    ) {
      this.selectedItemService1_Display =
        data.bkItemDescMobile1 + " (" + data.bkItemID1 + ")";
      this.selectedItemService1_Name = data.bkItemDescMobile1;
    }

    if (
      data.bkItemID2 != null &&
      data.bkItemID2 !== undefined &&
      data.bkItemID2 !== ""
    ) {
      this.selectedItemService2_Display =
        data.bkItemDescMobile2 + " (" + data.bkItemID2 + ")";
      this.selectedItemService2_Name = data.bkItemDescMobile2;
    }

    if (
      data.bkItemID3 != null &&
      data.bkItemID3 !== undefined &&
      data.bkItemID3 !== ""
    ) {
      this.selectedItemService3_Display =
        data.bkItemDescMobile3 + " (" + data.bkItemID3 + ")";
      this.selectedItemService3_Name = data.bkItemDescMobile3;
    }

    if (
      data.bkItemID4 != null &&
      data.bkItemID4 !== undefined &&
      data.bkItemID4 !== ""
    ) {
      this.selectedItemService4_Display =
        data.bkItemDescMobile4 + " (" + data.bkItemID4 + ")";
      this.selectedItemService4_Name = data.bkItemDescMobile4;
    }

    if (
      data.bkTherapistID1 != null &&
      data.bkTherapistID1 !== undefined &&
      data.bkTherapistID1 !== ""
    ) {
      this.selectedEmpolyee1_Display =
        data.bkTherapistName1 + " (" + data.bkTherapistID1 + ")";
      this.selectedEmpolyee1_Name = data.bkTherapistName1;
    }

    if (
      data.bkTherapistID2 != null &&
      data.bkTherapistID2 !== undefined &&
      data.bkTherapistID2 !== ""
    ) {
      this.selectedEmpolyee2_Display =
        data.bkTherapistName2 + " (" + data.bkTherapistID2 + ")";
      this.selectedEmpolyee2_Name = data.bkTherapistName2;
    }

    if (
      data.bkTherapistID3 != null &&
      data.bkTherapistID3 !== undefined &&
      data.bkTherapistID3 !== ""
    ) {
      this.selectedEmpolyee3_Display =
        data.bkTherapistName3 + " (" + data.bkTherapistID3 + ")";
      this.selectedEmpolyee3_Name = data.bkTherapistName3;
    }

    if (
      data.bkTherapistID4 != null &&
      data.bkTherapistID4 !== undefined &&
      data.bkTherapistID4 !== ""
    ) {
      this.selectedEmpolyee4_Display =
        data.bkTherapistName4 + " (" + data.bkTherapistID4 + ")";
      this.selectedEmpolyee4_Name = data.bkTherapistName4;
    }
  }

  getPreviousPatientName(shopID: string, patientID: string) {
    if (this.isNewPatient == false) {
      this.tPatientService.getDataById(shopID, patientID).subscribe((data) => {
        this.selectedPatient = data;
        this.getPatientLastPhysioInfo();
        (<FormControl>this.editForm.controls["bkPatientID"]).setValue(
          this.selectedPatient.patientID
        );
        const {patientChiName,patientSurname} = this.selectedPatient;
        this.bookingPatientDisplayName = patientSurname ? `${patientChiName}   ${patientSurname}` : `${patientChiName}`;
        // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + ' (' + this.selectedPatient.patientID + ')';

        (<FormControl>this.editForm.controls["bkPatientPhone"]).setValue(
          this.selectedPatient.patientPhone
        );

        if (!isNullOrUndefined(localStorage.getItem("action"))) {
          if (
            localStorage.getItem("action") ===
            PathAction.fromCreateWaitingConsultSaved
          ) {
            const displayData = new DisplayData();

            displayData.displayData1 = "已儲存";
            displayData.displayData2 =
              this.selectedPatient.patientChiName +
              "(" +
              this.selectedPatient.patientID +
              ")";

            const msg =
              " " + displayData.displayData1 + " " + displayData.displayData2;

            this.apiResultDialogService.openDialog(
              MastersKeyStringValue.ACTION_MessageDialog,
              "",
              status,
              msg
            );
          }

          localStorage.removeItem("action");
        }
      });
    }
  }

  getBookAuxService(bookedAux: tBookAuxModel[]) {
    this.log.i(this.TAG, "do getBookAuxService");

    this.tBookAuxService
      .getDataByInactiveStatus(NavigationComponent.selectedShopID, "N")
      .subscribe((data) => {
        this.bookingAuxList = data.sort((a, b) => a.bookAuxSeq - b.bookAuxSeq);
        // this.log.i(this.TAG, 'bookAux bookingAuxList = ' + JSON.stringify(this.bookingAuxList));

        // getcheckbox
        if (this.bookingAuxList.length > 0) {
          this.makeBookingAuxCheckBox(this.bookingAuxList, bookedAux);
        }
      });
  }

  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close("Close click");
  }

  searchPatientID() {
    this.log.i(this.TAG, "searchPatientID");
    // this.openPatientDialogModel(MastersKeyStringValue.ACTION_YNDialog);
    this.patientDialogService.openDialog().result.then(
      (result) => {
        // on close
        this.log.i(this.TAG, "searchPatientID data = " + result);
        this.selectedPatient = result;
        this.getPatientLastPhysioInfo();
        (<FormControl>this.editForm.controls["bkPatientID"]).setValue(
          this.selectedPatient.patientID
        );
        this.bookingPatientDisplayName = this.selectedPatient.patientChiName;
        // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + ' (' + this.selectedPatient.patientID + ')';

        (<FormControl>this.editForm.controls["bkPatientPhone"]).setValue(
          this.selectedPatient.patientPhone
        );

        // if (this.defaultEC != null && this.defaultEC != undefined) {
        //   (<FormControl>this.editForm.controls['clthTherapistName']).setValue(this.defaultEC.employeeChiName);
        //   (<FormControl>this.editForm.controls['clthTherapistID']).setValue(this.defaultEC.employeeID);
        // }
      },
      (reason) => {
        // on dismiss
        this.log.i(this.TAG, "searchPatientID reason = " + reason);
      }
    );
  }

  searchService(caseNum: number) {
    this.log.i(this.TAG, "searchService caseNum = " + caseNum);

    this.searchItemIDDialogService
      .openDialogWithSelectFilter(
        SearchItemIDDialogService.Filter_Search_Service_Only
      )
      .result.then(
        (result) => {
          this.log.i(this.TAG, "searchService data = " + result);

          if (caseNum === 1) {
            this.selectedItemService1 = result;

            (<FormControl>this.editForm.controls["bkItemID1"]).setValue(
              this.selectedItemService1.itemID
            );
            (<FormControl>this.editForm.controls["bkItemDescMobile1"]).setValue(
              this.selectedItemService1.itemDesc
            );

            this.selectedItemService1_Display =
              this.selectedItemService1.itemDesc +
              " (" +
              this.selectedItemService1.itemID +
              ")";
            this.selectedItemService1_Name = this.selectedItemService1.itemDesc;
          } else if (caseNum === 2) {
            this.selectedItemService2 = result;

            (<FormControl>this.editForm.controls["bkItemID2"]).setValue(
              this.selectedItemService2.itemID
            );
            (<FormControl>this.editForm.controls["bkItemDescMobile2"]).setValue(
              this.selectedItemService2.itemDesc
            );

            this.selectedItemService2_Display =
              this.selectedItemService2.itemDesc +
              " (" +
              this.selectedItemService2.itemID +
              ")";
            this.selectedItemService2_Name = this.selectedItemService2.itemDesc;
          } else if (caseNum === 3) {
            this.selectedItemService3 = result;

            (<FormControl>this.editForm.controls["bkItemID3"]).setValue(
              this.selectedItemService3.itemID
            );
            (<FormControl>this.editForm.controls["bkItemDescMobile3"]).setValue(
              this.selectedItemService3.itemDesc
            );

            this.selectedItemService3_Display =
              this.selectedItemService3.itemDesc +
              " (" +
              this.selectedItemService3.itemID +
              ")";
            this.selectedItemService3_Name = this.selectedItemService3.itemDesc;
          } else if (caseNum === 4) {
            this.selectedItemService4 = result;

            (<FormControl>this.editForm.controls["bkItemID4"]).setValue(
              this.selectedItemService4.itemID
            );
            (<FormControl>this.editForm.controls["bkItemDescMobile4"]).setValue(
              this.selectedItemService4.itemDesc
            );

            this.selectedItemService4_Display =
              this.selectedItemService4.itemDesc +
              " (" +
              this.selectedItemService4.itemID +
              ")";
            this.selectedItemService4_Name = this.selectedItemService4.itemDesc;
          }

          // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + " ("+this.selectedPatient.patientID+")";
        },
        (reason) => {
          this.log.i(this.TAG, "searchEmployee reason = " + reason);
        }
      );
  }

  searchEmployee(caseNum: number) {
    this.log.i(this.TAG, "searchEmployee caseNum = " + caseNum);

    this.searchEmployeeDialogService.openDialog(caseNum).result.then(
      (result) => {
        this.log.i(this.TAG, "searchEmployee data = " + result);

        if (caseNum === 1) {
          this.selectedEmpolyee1 = result;

          (<FormControl>this.editForm.controls["bkTherapistID1"]).setValue(
            this.selectedEmpolyee1.employeeID
          );
          (<FormControl>this.editForm.controls["bkTherapistName1"]).setValue(
            this.selectedEmpolyee1.employeeChiName
          );

          this.selectedEmpolyee1_Display =
            this.selectedEmpolyee1.employeeChiName +
            " (" +
            this.selectedEmpolyee1.employeeID +
            ")";
          this.selectedEmpolyee1_Name = this.selectedEmpolyee1.employeeChiName;
        } else if (caseNum === 2) {
          this.selectedEmpolyee2 = result;

          (<FormControl>this.editForm.controls["bkTherapistID2"]).setValue(
            this.selectedEmpolyee2.employeeID
          );
          (<FormControl>this.editForm.controls["bkTherapistName2"]).setValue(
            this.selectedEmpolyee2.employeeChiName
          );

          this.selectedEmpolyee2_Display =
            this.selectedEmpolyee2.employeeChiName +
            " (" +
            this.selectedEmpolyee2.employeeID +
            ")";
          this.selectedEmpolyee2_Name = this.selectedEmpolyee2.employeeChiName;
        } else if (caseNum === 3) {
          this.selectedEmpolyee3 = result;
          // this.editForm.get('bkTherapistID3').setValue(this.selectedEmpolyee3.employeeID);
          (<FormControl>this.editForm.controls["bkTherapistID3"]).setValue(
            this.selectedEmpolyee3.employeeID
          );
          (<FormControl>this.editForm.controls["bkTherapistName3"]).setValue(
            this.selectedEmpolyee3.employeeChiName
          );

          this.selectedEmpolyee3_Display =
            this.selectedEmpolyee3.employeeChiName +
            " (" +
            this.selectedEmpolyee3.employeeID +
            ")";
          this.selectedEmpolyee3_Name = this.selectedEmpolyee3.employeeChiName;
        } else if (caseNum === 4) {
          this.selectedEmpolyee4 = result;
          // this.editForm.get('bkTherapistID3').setValue(this.selectedEmpolyee3.employeeID);
          (<FormControl>this.editForm.controls["bkTherapistID4"]).setValue(
            this.selectedEmpolyee4.employeeID
          );
          (<FormControl>this.editForm.controls["bkTherapistName4"]).setValue(
            this.selectedEmpolyee4.employeeChiName
          );

          this.selectedEmpolyee4_Display =
            this.selectedEmpolyee4.employeeChiName +
            " (" +
            this.selectedEmpolyee4.employeeID +
            ")";
          this.selectedEmpolyee4_Name = this.selectedEmpolyee4.employeeChiName;
        }

        // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + " ("+this.selectedPatient.patientID+")";
      },
      (reason) => {
        this.log.i(this.TAG, "searchEmployee reason = " + reason);
      }
    );
  }

  getPatientName(shopID: string, patientID: string) {
    this.tPatientService.getDataById(shopID, patientID).subscribe((data) => {
      this.bookingPatientDisplayResultName = data.patientChiName;
    });
  }
  checkHKID() {
    this.CheckPatientHKIDMessage="";
    this.CheckPatientHKIDMessage_PASS="";

    this.isChecking = true; 
   var newPatientData = new tPatientModel_Encrypted();
  newPatientData.patientIHKID=this.CrypService.encryptStr(
    this.editForm.get("patientIHKID").value.trim()
  );
    var submittedData = {
      tPatientModel: newPatientData,
      clth: this.editForm.value,
    };
    this.tPatientService.checkPatientHKID(submittedData).subscribe(
      (data:any) => {
       
        this.isChecking = false;  
        if(data.isSuccess==false){

          this.translate
          .get("HKID_CHECKING_FAIL", {
            patientID: data.message,
          })
          .subscribe((x) => ( this.CheckPatientHKIDMessage = x));


        }else{
         this.translate
          .get("HKID_CHECKING_PASS") .subscribe((x) => (this.CheckPatientHKIDMessage_PASS= x));
        }

      },
      (error) => {
        // Handle error, optionally display an error message
        this.isChecking = false;  // Re-enable the button after the error
      }
    );
  }
  confirm() {
    if (this.isNewPatient == false) {
      this.log.i(
        this.TAG,
        `do confirm patientID ${
          this.selectedPatient.patientID
        } , bookedDate = ${this.editForm.get("bkBookedDate").value}`
      );
      this.submitted = true;

      console.log('this.editForm.valid = '+this.editForm.valid);
      console.table(this.editForm);


      if (this.editForm.valid) {
        const clthPatientID = (<FormControl>(
          this.editForm.controls["bkPatientID"]
        )).value;
        const clthBookNumber = (<FormControl>(
          this.editForm.controls["bkBookingNumber"]
        )).value;
        this.formValidSuccessSubmitted = true;
        const requestServiceName: string[] = [
          this.selectedItemService1_Name,
          this.selectedItemService2_Name,
          this.selectedItemService3_Name,
          this.selectedItemService4_Name,
        ];
        const requestTherapistName: string[] = [
          this.selectedEmpolyee1_Name,
          this.selectedEmpolyee2_Name,
          this.selectedEmpolyee3_Name,
          this.selectedEmpolyee4_Name,
        ];

        let consultServiceNamesDisplay = "";
        let consultTherapistsDisplay = "";

        // debugger

        for (let i = 0; i < requestServiceName.length; i++) {
          if (requestServiceName[i] !== null && requestServiceName[i] !== "") {
            consultServiceNamesDisplay += requestServiceName[i];

            if (i + 1 !== requestServiceName.length) {
              consultServiceNamesDisplay += " , ";
            }
          }
        }

        for (let i = 0; i < requestTherapistName.length; i++) {
          if (
            requestTherapistName[i] !== null &&
            requestTherapistName[i] !== ""
          ) {
            consultTherapistsDisplay += requestTherapistName[i];

            if (i + 1 !== requestTherapistName.length) {
              consultTherapistsDisplay += " ,";
            }
          }
        }

        const clthRequestServiceName = consultServiceNamesDisplay;

        const clthRequestTherapistName = consultTherapistsDisplay;

        const clthRemark = (<FormControl>this.editForm.controls["bkBookRemark"])
          .value;
        const clthAuxName = (<FormControl>(
          this.editForm.controls["bkBookAuxName"]
        )).value;

        (<FormControl>this.editForm.controls["clthPatientID"]).setValue(
          clthPatientID
        );
        (<FormControl>this.editForm.controls["clthBookNumber"]).setValue(
          clthBookNumber
        );
        (<FormControl>(
          this.editForm.controls["clthRequestServiceName"]
        )).setValue(clthRequestServiceName);
        (<FormControl>(
          this.editForm.controls["clthRequestTherapistName"]
        )).setValue(clthRequestTherapistName);
        (<FormControl>this.editForm.controls["clthRemark"]).setValue(
          clthRemark
        );
        (<FormControl>this.editForm.controls["clthAuxName"]).setValue(
          clthAuxName
        );

        (<FormControl>this.editForm.controls["lastModifyUserID"]).setValue(
          NavigationComponent.userID
        );

        const auxList: tBookAuxModel[] = new Array();
        const selectedOrderIds = this.editForm.value.bkBookAuxIDAll
          .map((v, i) => (v ? this.bookingAuxList[i].bookAuxID : null))
          .filter((v) => v !== null);

          // debugger

        this.log.i(
          this.TAG,
          "selectedOrderIds data = " +
            selectedOrderIds +
            " , selectedOrderIds size = " +
            selectedOrderIds.length
        );
        let serviceName = "";
        for (let pp = 0; pp < this.bookingAuxList.length; pp++) {
          for (let qq = 0; qq < selectedOrderIds.length; qq++) {
            if (selectedOrderIds[qq] === this.bookingAuxList[pp].bookAuxID) {
              auxList.push(this.bookingAuxList[pp]);
              serviceName += this.bookingAuxList[pp].bookAuxName + ",";
              break;
            }
          }
        }

        (<FormControl>this.editForm.controls["bkBookAuxID"]).setValue(
          JSON.stringify(auxList).toString()
        );

        (<FormControl>this.editForm.controls["clthAuxName"]).setValue(
          serviceName
        );
        this.tPatientService
          .getDataById(
            NavigationComponent.selectedShopID.toString(),
            clthPatientID
          )
          .subscribe((data) => {
            this.bookingPatientDisplayResultName = data.patientChiName;

            const patientIHKID = data.patientIHKID.toString();
            const decryptedHKID = this.CrypService.decryptStr(patientIHKID);

            const returnDisplayMsg = this.i18n.msg_patient_no_id_and_DOB;

            if (
              isNullOrUndefined(patientIHKID) ||
              patientIHKID === "" ||
              isNullOrUndefined(decryptedHKID) ||
              decryptedHKID === "" ||
              isNullOrUndefined(data.patientDob) ||
              !data.patientCaseDoctorID
            ) {
              const dialogRef = this.apiResultDialogService.openDialog(
                MastersKeyStringValue.ACTION_MessageDialog,
                "",
                "",
                returnDisplayMsg
              );
              this.formValidSuccessSubmitted = false;
              return;
            }
            this.log.i(
              this.TAG,
              "onsubmit data = " + JSON.stringify(this.editForm.value)
            );

            //get total CT today by patient , if total.consults > 1

            this.tWaitingConsultService
              .getTotalCtToday(clthPatientID)
              .subscribe((totalCT) => {
                if (totalCT.consults.length > 0) {
                  // patient has checked in CT on today
                  const str_time = this.datePipe.transform(
                    totalCT.consults[0].clthArrivalDateTime,
                    "h:mm a"
                  );
                  let warning = "";
                  this.translate
                    .get("cCheckIn_warning_has_already_checkIn", {
                      ID: clthPatientID,
                      Name: totalCT.patient.patientChiName,
                      arrivalDateTime: str_time,
                    })
                    .subscribe((x) => (warning = x));

                  const msgBox = new DisplayData();
                  msgBox.displayData6 = warning;
                  msgBox.displayData6_Style = { color: "red" };

                  this.apiResultDialogService
                    .openDialogV2(
                      MastersKeyStringValue.ACTION_YNDialog,
                      "",
                      "",
                      msgBox
                    )
                    .result.then((res) => {
                      if (res === "Y") {
                        //check in
                        this.tWaitingConsultService
                          .addData(this.editForm.value)
                          .subscribe(
                            (data) => {
                              this.log.i(
                                this.TAG,
                                "onSubmit success , data = " +
                                  JSON.stringify(data)
                              );

                              const returnData: any = data;
                              const displayData = new DisplayData();
                              displayData.displayData1 = "已新增";
                              displayData.displayData2 =
                                "姓名: " +
                                this.bookingPatientDisplayResultName +
                                ", 到診時間: " +
                                this.datepipe.transform(
                                  returnData.data.clthArrivalDateTime,
                                  "HH:mm"
                                );

                              if (
                                returnData.statusCode ===
                                StatusMessage.Status_OK
                              ) {
                                this.activeModal.close(StatusMessage.Status_OK);
                              }
                              this.apiResultHandlerService.ResultHandlerWithDisplayDate(
                                data,
                                "",
                                AppSettings.Path_tConsultHead_Waiting,
                                displayData
                              );
                            },
                            (err) => {
                              this.log.i(
                                this.TAG,
                                "onsubmit error = " + JSON.stringify(err)

                              );
                              if (
                                err.error.custStatusCode ==
                                "General_Dup_KeyCode"
                              ) {
                                this.apiResultDialogService.openSimpleDialog(
                                  MastersKeyStringValue.ACTION_MessageDialog,
                                  "The booking has created consultation !"
                                );
                                this.submitted = false;

                              } else {

                                if(err.error.custStatusCode){
                                  let errorMsg = "";
                                  switch(err.error.custStatusCode){
                                    case "ERROR_NO_HKID":
                                      errorMsg = err.error.custStatusCode;
                                      break;
                                    default:
                                      errorMsg = err.error.custStatusCode;
                                      break;
                                  }

                                  this.apiResultDialogService.openSimpleDialog(
                                    MastersKeyStringValue.ACTION_MessageDialog,
                                    errorMsg
                                  );

                                }else{
                                  this.apiResultHandlerService.ErrHandler();
                                }

                                // console.log(err);
                                // console.log("GGGGGWWWP");
                              }
                              this.formValidSuccessSubmitted = false;
                            }
                          );
                      }else{
                        this.activeModal.dismiss('Cross click');
                      }

                      console.log(res);
                      // debugger
                    },(error)=>{
                      this.activeModal.dismiss('Cross click');
                    });
                } else {
                  // patient has not CT on today
                  this.tWaitingConsultService
                    .addData(this.editForm.value)
                    .subscribe(
                      (data) => {
                        this.log.i(
                          this.TAG,
                          "onSubmit success , data = " + JSON.stringify(data)
                        );

                        const returnData: any = data;
                        const displayData = new DisplayData();
                        displayData.displayData1 = "";
                        displayData.displayData2 = "";

                        displayData.displayData1 = "已新增";
                        displayData.displayData2 =
                          "姓名: " +
                          this.bookingPatientDisplayResultName +
                          ", 到診時間: " +
                          this.datepipe.transform(
                            returnData.data.clthArrivalDateTime,
                            "HH:mm"
                          );
                        if (returnData.statusCode === StatusMessage.Status_OK) {
                          this.activeModal.close(StatusMessage.Status_OK);
                        }
                        this.apiResultHandlerService.ResultHandlerWithDisplayDate(
                          data,
                          "",
                          AppSettings.Path_tConsultHead_Waiting,
                          displayData
                        );
                      },
                      (err) => {
                        this.log.i(
                          this.TAG,
                          "onsubmit error = " + JSON.stringify(err)
                        );
                        if (err.error.custStatusCode == "General_Dup_KeyCode") {
                          this.apiResultDialogService.openSimpleDialog(
                            MastersKeyStringValue.ACTION_MessageDialog,
                            "The booking has created consultation !"
                          );
                          this.submitted = false;
                        } else {
                          this.apiResultHandlerService.ErrHandler();
                        }
                      }
                    );
                }
              });
          });
      }
    } else {
      console.log(JSON.stringify(this.editForm.value));

      if (this.editForm.get("patientIHKID").value) {
        this.editForm.patchValue({
          patientIHKID: this.editForm.get("patientIHKID").value.trim(),
        }); // clear hkid value space
      }

      this.submitted = true;

      if (this.editForm.invalid)
        return this.snackBar.open(
          "Please enter Patient Name/Tel./Date of Birth/HKID/Case Dr.",
          "OK",
          { duration: 3000 }
        );

      debugger;
      if (this.editForm.valid) {
        console.log(JSON.stringify(this.editForm.value));
        this.saveOption();
        const clthPatientID = (<FormControl>(
          this.editForm.controls["bkPatientID"]
        )).value;
        const clthBookNumber = (<FormControl>(
          this.editForm.controls["bkBookingNumber"]
        )).value;
        this.formValidSuccessSubmitted = true;
        const requestServiceName: string[] = [
          this.selectedItemService1_Name,
          this.selectedItemService2_Name,
          this.selectedItemService3_Name,
          this.selectedItemService4_Name,
        ];
        const requestTherapistName: string[] = [
          this.selectedEmpolyee1_Name,
          this.selectedEmpolyee2_Name,
          this.selectedEmpolyee3_Name,
          this.selectedEmpolyee4_Name,
        ];

        let consultServiceNamesDisplay = "";
        let consultTherapistsDisplay = "";

        for (let i = 0; i < requestServiceName.length; i++) {
          if (requestServiceName[i] !== null && requestServiceName[i] !== "") {
            consultServiceNamesDisplay += requestServiceName[i];

            if (i + 1 !== requestServiceName.length) {
              consultServiceNamesDisplay += " , ";
            }
          }
        }

        for (let i = 0; i < requestTherapistName.length; i++) {
          if (
            requestTherapistName[i] !== null &&
            requestTherapistName[i] !== ""
          ) {
            consultTherapistsDisplay += requestTherapistName[i];

            if (i + 1 !== requestTherapistName.length) {
              consultTherapistsDisplay += " ,";
            }
          }
        }

        const clthRequestServiceName = consultServiceNamesDisplay;

        const clthRequestTherapistName = consultTherapistsDisplay;

        const clthRemark = (<FormControl>this.editForm.controls["bkBookRemark"])
          .value;
        const clthAuxName = (<FormControl>(
          this.editForm.controls["bkBookAuxName"]
        )).value;

        (<FormControl>this.editForm.controls["clthPatientID"]).setValue(
          clthPatientID
        );
        (<FormControl>this.editForm.controls["clthBookNumber"]).setValue(
          clthBookNumber
        );
        (<FormControl>(
          this.editForm.controls["clthRequestServiceName"]
        )).setValue(clthRequestServiceName);
        (<FormControl>(
          this.editForm.controls["clthRequestTherapistName"]
        )).setValue(clthRequestTherapistName);
        (<FormControl>this.editForm.controls["clthRemark"]).setValue(
          clthRemark
        );
        (<FormControl>this.editForm.controls["clthAuxName"]).setValue(
          clthAuxName
        );

        (<FormControl>this.editForm.controls["lastModifyUserID"]).setValue(
          NavigationComponent.userID
        );

        const auxList: tBookAuxModel[] = new Array();
        const selectedOrderIds = this.editForm.value.bkBookAuxIDAll
          .map((v, i) => (v ? this.bookingAuxList[i].bookAuxID : null))
          .filter((v) => v !== null);

        this.log.i(
          this.TAG,
          "selectedOrderIds data = " +
            selectedOrderIds +
            " , selectedOrderIds size = " +
            selectedOrderIds.length
        );
        let serviceName = "";
        for (let pp = 0; pp < this.bookingAuxList.length; pp++) {
          for (let qq = 0; qq < selectedOrderIds.length; qq++) {
            if (selectedOrderIds[qq] === this.bookingAuxList[pp].bookAuxID) {
              auxList.push(this.bookingAuxList[pp]);
              serviceName += this.bookingAuxList[pp].bookAuxName + ",";
              break;
            }
          }
        }

        (<FormControl>this.editForm.controls["bkBookAuxID"]).setValue(
          JSON.stringify(auxList).toString()
        );

        (<FormControl>this.editForm.controls["clthAuxName"]).setValue(
          serviceName
        );

        const patientPhone_str = this.CrypService.encryptStr(
          this.editForm.get("bkPatientPhone").value
        );
        const encryptedHKID = this.CrypService.encryptStr(
          this.editForm.get("patientIHKID").value
        );
        let patientPhone2_str = this.CrypService.encryptStr("0");

        var newPatientData = new tPatientModel_Encrypted();
        newPatientData.patientPhone_str = patientPhone_str;
        newPatientData.patientPhone2_str = patientPhone2_str;
        newPatientData.patientCaseDoctorID =
          this.editForm.get("patientCaseDr").value;
        newPatientData.patientTypeID = this.editForm.get("patientType").value;
        newPatientData.patientGender = this.editForm.get("patientGender").value;
        newPatientData.patientRemark2 =
          this.editForm.get("patientRemark2").value;
        newPatientData.patientIHKID = encryptedHKID;
        newPatientData.patientDob = this.editForm.get("patientDob").value;
        newPatientData.patientChiName =
          this.editForm.get("bkPatientName").value;
        newPatientData.patientSurname =
          this.editForm.get("patientSurname").value;
        newPatientData.patientAddress =
          this.editForm.get("patientAddress").value;
        newPatientData.patientAddress_str =
          this.editForm.get("patientAddress").value;
        newPatientData.patientFirstName = "";
        newPatientData.patientTitle = 1;
        newPatientData.phoneAreaCode = "";
        newPatientData.patientMedCard1 = "";
        newPatientData.patientMedCard2 = "";
        newPatientData.patientRemark3 = "N";
        newPatientData.inActive = "N";
        newPatientData.patientIHKID_str = encryptedHKID;
        newPatientData.shopID = NavigationComponent.selectedShopID;
        newPatientData.patientNonHKIDHolder = this.editForm.get(
          "patientNonHKIDHolder"
        ).value
          ? "Y"
          : "N";
        var submittedData = {
          tPatientModel: newPatientData,
          clth: this.editForm.value,
        };
        console.log(JSON.stringify(submittedData));

        this.tPatientService.newPatientCheckIn(submittedData).subscribe(
          (data: any) => {
            this.log.i(
              this.TAG,
              "onSubmit success , data = " + JSON.stringify(data)
            );

            const returnData: any = data;
            const displayData = new DisplayData();
            displayData.displayData1 = "";
            displayData.displayData2 = "";
            if (returnData.isSuccess == true) {
              displayData.displayData1 = "Added";
              displayData.displayData2 =
                "Patient Name: " +
                this.editForm.get("bkPatientName").value.toString() +
                ", Consultation Time: " +
                this.datepipe.transform(
                  returnData.data.clthArrivalDateTime,
                  "HH:mm"
                );
              if (returnData.statusCode === StatusMessage.Status_OK) {
                this.activeModal.close(StatusMessage.Status_OK);
                this.apiResultHandlerService.ResultHandlerWithDisplayDate(
                  data,
                  "",
                  AppSettings.Path_tConsultHead_Waiting,
                  displayData
                );
              }
            } else {
              //  this.log.i(this.TAG, 'onSubmit fail , data = ' + JSON.stringify(data));

              this.submitted = false;
              this.formValidSuccessSubmitted = false;
              displayData.displayData1 = data.message;
              displayData.displayData2 = "";
              this.apiResultHandlerService.ResultHandlerWithDisplayDate(
                data,
                "",
                AppSettings.Path_tConsultHead_Waiting,
                displayData
              );
            }
          },

          (err) => {
            this.log.i(this.TAG, "onsubmit error = " + JSON.stringify(err));
            this.apiResultHandlerService.ErrHandler();
          }
        );
      }
    }
  }

  onAuxChange(auxID) {
    this.log.i(this.TAG, "onAuxChange auxID = " + auxID);

    if (isNullOrUndefined(this.bookingAuxList)) {
      return;
    }

    for (let i = 0; i < this.bookingAuxList.length; i++) {
      if (auxID === this.bookingAuxList[i].bookAuxID) {
        (<FormControl>this.editForm.controls["bkBookAuxName"]).setValue(
          this.bookingAuxList[i].bookAuxName
        );

        break;
      }
    }
  }

  newPatientRecord() {
    this.log.i(this.TAG, "do newPatientRecord");
    // this.newPatientDialogService.openDialog();

    this.newPatientDialogService.openDialog().result.then(
      (result) => {
        // on close
        this.log.i(this.TAG, "searchPatientID data = " + result);
        this.selectedPatient = result;
        this.getPatientLastPhysioInfo();
        (<FormControl>this.editForm.controls["bkPatientID"]).setValue(
          this.selectedPatient.patientID
        );
        this.bookingPatientDisplayName = this.selectedPatient.patientChiName;
        // this.bookingPatientDisplayName = this.selectedPatient.patientChiName + ' (' + this.selectedPatient.patientID + ')';

        (<FormControl>this.editForm.controls["bkPatientPhone"]).setValue(
          this.selectedPatient.patientPhone
        );
      },
      (reason) => {
        // on dismiss
        this.log.i(this.TAG, "searchPatientID reason = " + reason);
      }
    );
  }

  setDatePickerZ() {
    const el = document.getElementsByClassName("mat-datepicker-popup").item(0);
    this.ren.setStyle(el, "z-index", "1500");
  }

  ClearSelectBookAux() {
    (<FormControl>this.editForm.controls["bkBookAuxID"]).setValue(0);
    (<FormControl>this.editForm.controls["bkBookAuxName"]).setValue("");
  }

  ClearSelectedItem(caseNum: number) {
    this.log.i(this.TAG, "ClearSelectedItem caseNum = " + caseNum);

    if (caseNum === 1) {
      this.selectedItemService1 = null;
      this.selectedItemService1_Display = "";
      this.selectedItemService1_Name = "";

      (<FormControl>this.editForm.controls["bkItemID1"]).setValue("");
      (<FormControl>this.editForm.controls["bkItemDescMobile1"]).setValue("");
    } else if (caseNum === 2) {
      this.selectedItemService2 = null;
      this.selectedItemService2_Display = "";
      this.selectedItemService2_Name = "";

      (<FormControl>this.editForm.controls["bkItemID2"]).setValue("");
      (<FormControl>this.editForm.controls["bkItemDescMobile2"]).setValue("");
    } else if (caseNum === 3) {
      this.selectedItemService3 = null;
      this.selectedItemService3_Display = "";
      this.selectedItemService3_Name = "";

      (<FormControl>this.editForm.controls["bkItemID3"]).setValue("");
      (<FormControl>this.editForm.controls["bkItemDescMobile3"]).setValue("");
    } else if (caseNum === 4) {
      this.selectedItemService4 = null;
      this.selectedItemService4_Display = "";
      this.selectedItemService4_Name = "";

      (<FormControl>this.editForm.controls["bkItemID4"]).setValue("");
      (<FormControl>this.editForm.controls["bkItemDescMobile4"]).setValue("");
    }
  }

  ClearSelectedEmpolyee(caseNum: number) {
    this.log.i(this.TAG, "ClearSelectedEmpolyee caseNum = " + caseNum);

    if (caseNum === 1) {
      this.selectedEmpolyee1 = null;
      this.selectedEmpolyee1_Display = "";
      this.selectedEmpolyee1_Name = "";

      (<FormControl>this.editForm.controls["bkTherapistID1"]).setValue("");
      (<FormControl>this.editForm.controls["bkTherapistName1"]).setValue("");
    } else if (caseNum === 2) {
      this.selectedEmpolyee2 = null;
      this.selectedEmpolyee2_Display = "";
      this.selectedEmpolyee2_Name = "";

      (<FormControl>this.editForm.controls["bkTherapistID2"]).setValue("");
      (<FormControl>this.editForm.controls["bkTherapistName2"]).setValue("");
    } else if (caseNum === 3) {
      this.selectedEmpolyee3 = null;
      this.selectedEmpolyee3_Display = "";
      this.selectedEmpolyee3_Name = "";

      (<FormControl>this.editForm.controls["bkTherapistID3"]).setValue("");
      (<FormControl>this.editForm.controls["bkTherapistName3"]).setValue("");
    } else if (caseNum === 4) {
      this.selectedEmpolyee4 = null;
      this.selectedEmpolyee4_Display = "";
      this.selectedEmpolyee4_Name = "";

      (<FormControl>this.editForm.controls["bkTherapistID4"]).setValue("");
      (<FormControl>this.editForm.controls["bkTherapistName4"]).setValue("");
    }
  }

  setDefaultLanguageString(language: String) {
    switch (language) {
      case SystemDefaultModel.Language_Chinese:
        this.clthFollowUpList = ChineseDefaultModel.InActiveList;
        break;
      case SystemDefaultModel.Language_English:
        this.clthFollowUpList = EnglishDefaultModel.InActiveList;
        break;
      default:
        this.clthFollowUpList = ChineseDefaultModel.InActiveList;
        break;
    }
  }

  makeBookingAuxCheckBox(
    bookAuxList: tBookAuxModel[],
    bookedAuxList: tBookAuxModel[]
  ) {
    of(bookAuxList).subscribe((bookAuxList) => {
      this.bookingAuxData = bookAuxList;
      this.addCheckboxes(bookedAuxList);
    });
  }

  private addCheckboxes(bookedAuxList: tBookAuxModel[]) {
    this.bookingAuxData.forEach((o, i) => {
      // const control = new FormControl(i === 0); // if first item set to true, else false
      let control = new FormControl();

      const checkBookingModel: tBookAuxModel = this.bookingAuxData[i];

      if (bookedAuxList != null) {
        for (let pp = 0; pp < bookedAuxList.length; pp++) {
          if (bookedAuxList[pp].bookAuxID === checkBookingModel.bookAuxID) {
            control = new FormControl(i === i);
            break;
          }
        }
      }

      (this.editForm.controls.bkBookAuxIDAll as FormArray).push(control);
    });
  }

  changeTherapistID() {
    this.log.i(this.TAG, "do changeTherapistID");
    for (let i = 0; i < this.ecTypeSelectList.length; i++) {
      // this.ecTypeSelectList[i].fromToWH = this.editForm.get('fromToWH').value;

      if (
        this.ecTypeSelectList[i].employeeID ==
        this.editForm.get("clthTherapistID").value
      ) {
        (<FormControl>this.editForm.controls["clthTherapistName"]).setValue(
          this.ecTypeSelectList[i].employeeChiName
        );
        break;
      }
      // this.log.i(this.TAG, i + ' , fromToWH = ' + this.ecTypeSelectList[i].fromToWH + ' ,whWhseID.whWhseID = ' + this.editForm.get('fromToWH').value);
    }

    // this.dataSource = new MatTableDataSource<tInvtModel>(this.dataList);
  }

  editPatient() {
    const clthPatientID = (<FormControl>this.editForm.controls["bkPatientID"])
      .value;

    if (clthPatientID !== "") {
      // localStorage.getItem('');

      localStorage.removeItem("action");
      localStorage.setItem("action", PathAction.fromCreateWaitingConsult);

      localStorage.removeItem("systemPatientShopID");
      localStorage.setItem(
        "systemPatientShopID",
        NavigationComponent.selectedShopID.toString()
      );

      localStorage.removeItem("systemMasterPatientID");
      localStorage.setItem("systemMasterPatientID", clthPatientID);

      localStorage.removeItem("bookingNum");
      localStorage.setItem("bookingNum", this.bookingNum);

      sessionStorage.setItem(
        "checkIn_selected_clthTherapistID",
        this.editForm.get("clthTherapistID").value
      );

      this.router.navigate([
        AppSettings.Path_tPatient + AppSettings.PATH_EDIT + "/consult",
      ]);

      this.activeModal.dismiss("Cross click");
    }
  }

  GetAuxListAll(form) {
    // editForm.controls.bkBookAuxIDAll.controls
    var auxListForm: FormGroup = this.formBuilder.group({
      bkBookAuxIDAll: new FormArray([]),
    });

    return form.controls;
  }

  getCaseDoctorName() {
    if (!this.selectedPatient)
      return this.i18n.msg_caseDoctor_no_select_patient;
    if (!this.selectedPatient.patientCaseDoctorID)
      return this.i18n.msg_caseDoctor_no_caseDoctor;
    if (!this.ecTypeSelectList) return "";
    const caseDr = this.ecTypeSelectList.find(
      (emp) => emp.employeeID === this.selectedPatient.patientCaseDoctorID
    ).employeeChiName;

    return caseDr;
  }

  patientLastPhysio = {
    therapistName: "",
    lastDate: "",
  };

  getPatientLastPhysioInfo() {
    const { patientID } = this.selectedPatient;
    const shopID = NavigationComponent.selectedShopID.toString();
    this.tOnConsultService
      .getLastPhysioInfo(shopID, patientID)
      .subscribe((x) => {
        if (x.length > 0) {
          const info = x[x.length - 1];
          const lastDate = this.datePipe.transform(
            info.endDateTime,
            AppSettings.dateFormat
          );
          this.patientLastPhysio.lastDate = lastDate;
          this.patientLastPhysio.therapistName = info.cltdTherapistName;
          this.patientLastPhysioRemark = "";
        } else {
          this.patientLastPhysioRemark = "";
        }
      });
  }

  decodedHKID() {
    if (!this.selectedPatient || !this.selectedPatient.patientIHKID) return "";
    return this.CrypService.decryptStr(this.selectedPatient.patientIHKID);
  }

  getPatientTypeList(/*pTypeID: number*/) {
    this.tPatientTypeService.getAllData().subscribe((data) => {
      this.patientTypeID_selection = data;
      this.editForm.get("patientType").setValue(data[0].pTypeID);

      this.log.i(
        this.TAG,
        "getPatientTypeList data = " +
          JSON.stringify(this.patientTypeID_selection)
      );
    });
  }

  getGender() {
    console.log("do getPatientGender");
    this.SimpleConfigService.getAllData().subscribe(
      (data) => {
        console.log("getPatientGender success");

        this.genderList = data.patientGenderModelList;
        this.genderTitleList = data.patientGenderTitleModelList;
        this.editForm.get("patientGender").setValue(this.genderList[0].id);
      },
      (err) => {
        console.log("getPatientGender error");
      }
    );
  }

  onInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.filteredOptions = this.options.filter((option) =>
      option.toLowerCase().includes(input.toLowerCase())
    );
    // this.activeOptionIndex = -1;
  }

  onKeydown(event: KeyboardEvent): void {
    if (this.filteredOptions.length === 0) {
      return;
    }

    if (event.key === "ArrowDown") {
      this.activeOptionIndex =
        (this.activeOptionIndex + 1) % this.filteredOptions.length;
      event.preventDefault();
    } else if (event.key === "ArrowUp") {
      this.activeOptionIndex =
        (this.activeOptionIndex - 1 + this.filteredOptions.length) %
        this.filteredOptions.length;
      event.preventDefault();
    } else if (event.key === "Tab" && this.activeOptionIndex >= 0) {
      this.activeOptionIndex =
        (this.activeOptionIndex + 1) % this.filteredOptions.length;
      event.preventDefault();
    } else if (event.key === "Enter") {
      this.selectOption(this.filteredOptions[this.activeOptionIndex]);
      event.preventDefault();
    }
  }

  selectOption(option: string): void {
    this.userInput = option;
    this.filteredOptions = [];
    this.editForm.get("patientRemark2").setValue(option);
    //this.activeOptionIndex = -1;
  }

  saveOption(): void {
    var option = this.editForm.get("patientRemark2").value;
    if (option == null || option == "") {
    } else {
      if (option && !this.options.includes(option)) {
        this.options.push(option);
        localStorage.setItem("userOptions", JSON.stringify(this.options));
      }
    }
  }

  loadOptions(): void {
    const savedOptions = localStorage.getItem("userOptions");
    if (savedOptions) {
      this.options = JSON.parse(savedOptions);
      this.activeOptionIndex = 0;
    } else {
      this.activeOptionIndex = -1;
    }
  }

  onBlur(): void {
    setTimeout(() => {
      this.filteredOptions = [];
    }, 200);
  }

  validateHKIDRegex(idCardNumber: string) {
    return false;
  }

  hkid_error_message;
  AZDict = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    O: 24,
    P: 25,
    Q: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    V: 31,
    W: 32,
    X: 33,
    Y: 34,
    Z: 35,
  };
  validateHongKongIDCard(): boolean {
    if (this.editForm.value.patientNonHKIDHolder) {
      this.hkid_error_message = "";
      return true;
    }
    if (
      this.editForm.get("patientIHKID").value == null ||
      this.editForm.get("patientIHKID").value == ""
    ) {
      return false;
    }
    var id = this.editForm.get("patientIHKID").value;
    //Remove any whitespaces
    id = id.replace(/\s/g, "");

    if (id.length === 0) {
      this.hkid_error_message = "";
      return false;
    }

    //Check length
    if (id.length !== 8 && id.length !== 9) {
      //console.log('hkid length incorrect')
      this.translate
        .get("patient_alert_hkid_format_incorrect")
        .subscribe((x) => (this.hkid_error_message = x));
      // this.hkid_error_message = 'Incorrect HKID ! Please reinput again.';
      return false;
    } else {
      console.log("hkid.len right");
      this.hkid_error_message = "";
    }

    //Extract the check digit (last character)
    const checkCode = this.charToNumber(id[id.length - 1]);

    let firstCharValue = this.charToNumber(id[0]);
    // console.log('firstCharValue = '+firstCharValue)
    // Check if the first character is a letter between 'A' and 'Z'
    if (firstCharValue < 10 || firstCharValue > 35) {
      this.translate
        .get("patient_alert_hkid_format_incorrect")
        .subscribe((x) => (this.hkid_error_message = x));
      // this.hkid_error_message='First Char is not A-Z';
      return false;
    }

    let sum = (firstCharValue * 8) % 11;
    // console.log(`digit(${firstCharValue}) , total:(${sum})`);

    for (let i = 1; i < id.length - 1; i++) {
      const digit = Number(id[i]);
      const total = digit * (id.length - i);
      // console.log(`digit(${digit}) , total:(${total % 11})`);

      sum += total;
    }

    if (id.length === 8) sum += 5;

    //add last char
    sum += checkCode % 11;

    const result = sum % 11;

    if (result != 0) {
      this.translate
        .get("patient_alert_hkid_format_incorrect")
        .subscribe((x) => (this.hkid_error_message = x));
    } else {
      this.hkid_error_message = "";
    }

    return false;
  }

  charToNumber(char) {
    char = char.toUpperCase();
    if (this.AZDict[char]) {
      return this.AZDict[char];
    } else {
      return char; // or some default value
    }
  }
  NewIsHKID(str) {
    if (this.editForm.value.patientNonHKIDHolder) {
      this.hkid_error_message = "";
      return true;
    }

    let strValidChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if (str.length < 8) {
      this.translate
        .get("patient_alert_hkid_format_incorrect")
        .subscribe((x) => (this.hkid_error_message = x));
      return false;
    }
    str = str.toUpperCase();
    let hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;
    let matchArray = str.match(hkidPat);
    if (matchArray == null) {
      this.translate
        .get("patient_alert_hkid_format_incorrect")
        .subscribe((x) => (this.hkid_error_message = x));
      return false;
    }
    let charPart = matchArray[1];
    let numPart = matchArray[2];
    let checkDigit = matchArray[3];
    let checkSum = 0;
    if (charPart.length == 2) {
      checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
      checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
    } else {
      checkSum += 9 * 36;
      checkSum += 8 * (10 + strValidChars.indexOf(charPart));
    }

    for (let i = 0, j = 7; i < numPart.length; i++, j--) {
      checkSum += j * numPart.charAt(i);
    }
    let remaining = checkSum % 11;
    let verify = remaining == 0 ? 0 : 11 - remaining;

    const isCorrect =
      verify == checkDigit || (verify == 10 && checkDigit == "A");
    if (isCorrect) {
      this.hkid_error_message = "";
    } else {
      this.translate
        .get("patient_alert_hkid_format_incorrect")
        .subscribe((x) => (this.hkid_error_message = x));
    }
    return isCorrect;
  }
}
